export const toDropdownOptions = (users) => {
  return users?.data?.map(user => ({
    id: user.id,
    text: user.stampNumber ? `${user.name} ${user.surname} (${user.stampNumber})` : `${user.name} ${user.surname}`
  })) ?? [];
};